import s from "./styles";
import List from "../../components/common/ListWithMoreOptions";
import BottomPageSelectorWithPagination, {
  usePagination,
} from "../../components/common/BottomPageSelectorWithPagination";
import { usePaginatedData } from "../../helpers/hooks";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { secondsToTime } from "../../helpers/dataHelper";
import Loading from "components/common/loading";

const GeneralTable = ({ clockSessions, mappedUsers, loading }) => {
  const { t } = useTranslation();

  const { sorting, setSorting, search, pagination, setPagination } =
    usePagination("name");

  const data = useMemo(() => {
    const mappedData = {};
    clockSessions.forEach((clockSession) => {
      const day = moment(clockSession.creationDatetime).format("L");
      const key = `${clockSession.userId}_${day}`;
      if (!mappedData[key]) {
        mappedData[key] = {
          name:
            mappedUsers[clockSession.userId]?.fullName || clockSession.userId,
          day,
          pauses: 0,
          workedUp: 0,
          total: 0,
        };
      }
      if (clockSession.type === "pause") {
        mappedData[key].pauses =
          mappedData[key].pauses + clockSession.sessionDuration;
      } else {
        mappedData[key].workedUp =
          mappedData[key].workedUp + clockSession.sessionDuration;
      }
    });

    return Object.keys(mappedData).map((key) => ({
      ...mappedData[key],
      pauses: secondsToTime(mappedData[key].pauses, t),
      workedUp: secondsToTime(mappedData[key].workedUp, t),
      total: secondsToTime(
        mappedData[key].pauses + mappedData[key].workedUp,
        t
      ),
    }));
  }, [clockSessions, search]);
  const generalData = usePaginatedData(data, pagination, sorting, (item) => [
    item.name,
    item.day,
    item.pauses,
    item.workedUp,
    item.total,
  ]);

  const columns = useMemo(() => {
    return [
      {
        title: t("containers.ClockSessions.worker"),
        sortable: true,
        columnId: "name",
      },
      {
        title: t("containers.ClockSessions.day"),
        sortable: true,
        columnId: "day",
      },
      {
        title: t("containers.ClockSessions.pauses"),
        sortable: true,
        columnId: "pauses",
      },
      {
        title: t("containers.ClockSessions.workedUp"),
        sortable: true,
        columnId: "workedUp",
      },
      {
        title: t("containers.ClockSessions.total"),
        sortable: true,
        columnId: "total",
      },
    ];
  }, []);

  const columnWidths = `1fr 1fr 1fr 1fr 1fr`;
  return (
    <>
      <s.ListContainer>
        {loading ? (
          <Loading />
        ) : (
          <List
            width={"800px"}
            data={generalData}
            columns={columns}
            sorting={sorting}
            moreOption={false}
            changeSorting={(columnId, order) => setSorting({ columnId, order })}
            tableStyle={{
              gridTemplateColumns: columnWidths,
            }}
          />
        )}
      </s.ListContainer>
      <BottomPageSelectorWithPagination
        pagination={pagination}
        setPagination={setPagination}
        length={data.length}
      />
    </>
  );
};
export default GeneralTable;
